import { VpIconButton } from '@vtmn-play/react'
import { VpChevronLeftIcon, VpChevronRightIcon } from '@vtmn-play/icons/react'
import { useTranslation } from 'react-i18next'
import { HOMEPAGE_EVENTS } from 'core/constants/homepage-analytics'
import { trackHomepageEvent } from '../../analytics/track-homepage-event'
import { addWeeks, subWeeks } from 'date-fns'
import DateUtils from 'core/utils/date'

interface WeeklyTitleProps {
  currentWeekNumber: number
  weekDate: Date
  onWeekDateChange: (weekDate: Date) => void
}

const getTitleTranslationKey = (currentWeekNumber: number, weekNumber: number) => {
  if (currentWeekNumber === weekNumber) {
    return 'general.homepage.week.this'
  }
  return 'general.homepage.week.last'
}

const WeeklyTitle = ({ currentWeekNumber, weekDate, onWeekDateChange }: WeeklyTitleProps) => {
  const { t } = useTranslation()
  const weekNumber = DateUtils.getWeekNumber(weekDate)

  const onClickLastWeek = () => {
    trackHomepageEvent(HOMEPAGE_EVENTS.CLICK_LAST_WEEK, { week: currentWeekNumber })
    onWeekDateChange(subWeeks(weekDate, 1))
  }

  const onClickNextWeek = () => {
    trackHomepageEvent(HOMEPAGE_EVENTS.CLICK_NEXT_WEEK, { week: currentWeekNumber })
    onWeekDateChange(addWeeks(weekDate, 1))
  }

  return (
    <div className="mg-weekly-title">
      {
        <VpIconButton
          variant="ghost"
          variantStyle="regular"
          size="small"
          onClick={onClickLastWeek}
          disabled={currentWeekNumber !== weekNumber}
          data-testid="weekly-last-week-button"
        >
          <VpChevronLeftIcon />
        </VpIconButton>
      }
      <div>
        <span className="vp-subtitle-l">{t(getTitleTranslationKey(currentWeekNumber, weekNumber))} </span>
        <span className="vp-body-s">({t('general.weekLetter') + weekNumber.toString()})</span>
      </div>
      {
        <VpIconButton
          variant="ghost"
          variantStyle="regular"
          size="small"
          onClick={onClickNextWeek}
          disabled={currentWeekNumber === weekNumber}
          data-testid="weekly-next-week-button"
        >
          <VpChevronRightIcon />
        </VpIconButton>
      }
    </div>
  )
}

export default WeeklyTitle
